// extracted by mini-css-extract-plugin
export default {"root":"SharingNewUnMount__root--3SI1N","root_responsive":"SharingNewUnMount__root_responsive--22Jy_"};